export default __webpack_public_path__ + "static/media/icon.electricity generators.d02d5346.svg";